import { Modal, message } from "antd";
import { AxiosError } from "axios";
import qs from "qs";
import { omit } from "underscore";

import authorizeStore from "@/stores/authorizeStore";

import { axiosInstance } from ".";
import config from "../config";
import { ICustomRequestConfig, IResponseBase } from "./interfaces";

let isUnAuthorizeDialogShowing = false;
function handleUnauthorize(msg: string) {
  if (isUnAuthorizeDialogShowing) return;
  isUnAuthorizeDialogShowing = true;
  Modal.confirm({
    content: msg,
    cancelText: "留在当前页",
    okText: "返回登录页",
    onOk: () => {
      isUnAuthorizeDialogShowing = false;
      // 移除用户信息返回至登录页
      window.location.hash = "/login";
    },
  });
}

axiosInstance.interceptors.request.use((requestConfig) => {
  // 如果token存在将其加入 headers
  if (!requestConfig.allowAnonymity && authorizeStore.token) {
    requestConfig.headers.Authorization = `Bearer ${authorizeStore.token}`;
  }

  if (requestConfig.params && requestConfig.params.pageNo) {
    requestConfig.params = { ...omit(requestConfig.params, "pageNo"), pageNum: requestConfig.params.pageNo };
  }

  return requestConfig;
});

axiosInstance.interceptors.response.use(
  (response) => {
    const { data } = response as { data: { code: number; msg: string } };

    // 文件不处理
    if (data instanceof Blob) {
      return response;
    }

    const { config } = response as { config: ICustomRequestConfig };

    let businessData = omit(data, ["code", "msg"]);

    if (data.code === 200) {
      if (config.desc && config.showMessage) {
        message.success(`${config.desc}成功`);
      }
      if (typeof businessData === "object" && businessData !== null && "rows" in businessData) {
        // @ts-ignore
        businessData.list = [...businessData.rows];
      }
      if (typeof config?.formatter === "function") {
        businessData = config.formatter(businessData);
      }
    } else if (data.code === 401) {
      handleUnauthorize("登录状态已过期");
    } else if (config.desc && config.showMessage) {
      message.error(data.msg || `${config.desc}失败`);
    }

    response.data = {
      success: data.code === 200 ? 0 : data.code,
      message: data.msg,
      data: businessData,
    };

    return response;
  },
  (error) => {
    if (error instanceof Error) {
      if ("response" in (error as AxiosError)) {
        const ex = error as AxiosError;
        if (ex.response?.status === 401) {
          authorizeStore.clean();
          handleUnauthorize(ex.response.data as any);
        }
      }
    }
  },
);

axiosInstance.defaults.headers.common = {
  "Content-Type": "application/json",
};

axiosInstance.defaults.baseURL = config.baseURL;
axiosInstance.defaults.timeout = 120 * 1000;
axiosInstance.defaults.paramsSerializer = (params) => qs.stringify(params);
